// ハンバーガーメニューの表示 / 非表示
// -------------------------------------------------------------------------
const hamburgerBtn = document.getElementById('illumi-p-hamburger-btn');

hamburgerBtn.addEventListener('click', () => {
    document.documentElement.classList.toggle('is-noscroll');
    document.documentElement.classList.toggle('is-hamburger-active');
    hamburgerBtn.classList.toggle('is-active');
});

// ハンバーガーメニューを閉じる関数
const removeHamburgerActiveClass = () => {
    document.documentElement.classList.remove('is-hamburger-active');
};

// ハンバーガーメニューをブラウザバックで表示しない
const hamburgerNavItem = document.querySelectorAll('.illumi-p-header__item a');
const headerLogo = document.querySelector('.illumi-p-header__logo a');

[...hamburgerNavItem, headerLogo].forEach((element) => {
    element.addEventListener('click', removeHamburgerActiveClass);
});

// リサイズでハンバーガーメニューを閉じる
window.addEventListener('resize', function () {
    if (document.documentElement.classList.contains('is-hamburger-active') && window.innerWidth >= 1024) {
        removeHamburgerActiveClass();
    }
});
